import { helpers, type PluginConfiguration } from '../helpers'
import { icons } from '../icons'

export const analytics: PluginConfiguration = {
  name: 'Analytics',
  id: 'analytics',
  icon: icons.analytics,
  extra: '',
  layout: {
    type: 'table',
    columns: [['Key', 'Value']],
    searchColumnsIndex: [0, 1],
    // @ts-expect-error Fix TypeScript type
    render: (event: string, values?: Record<string, unknown>) =>
      helpers.updateTable(analytics.id, 'append', {
        rows: [
          {
            dataAttributes: {
              'data-name': event,
              'data-properties': values ?? {},
            },
            data: [event, helpers.convertObjectToString(values ?? {})],
          },
        ],
        isRowClickable: true,
      }),
  },
  // @ts-expect-error Fix TypeScript type
  render: (...data: unknown[]) => analytics.layout.render(...data),
  init: () => {
    document
      .querySelector(`[data-fu-tools-table-content=${analytics.id}]`)
      ?.addEventListener('click', event => {
        const tableRow = (event.target as HTMLElement).closest('[fu-tools-table-row]')
        if (!tableRow) {
          return
        }

        const name = tableRow.getAttribute('data-name') ?? ''
        const properties = tableRow.getAttribute('data-properties') ?? '{}'

        const createdElements = helpers.createHTMLElements([
          { className: 'flex font-bold border-[#334155] border-b pb-4', content: name },
          {
            className:
              'border-[#334155] border-b py-4 cursor-pointer hover:bg-[#1e293b] transition-all duration-200',
            content: helpers.convertObjectToSanitizedDialogHTML(JSON.parse(properties)),
            copyOnClick: true,
            dangerouslySetInnerHTML: true,
          },
        ])
        helpers.showModal(createdElements)
      })
  },
}
